import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { AuthCard } from './_AuthLayout';
import { api } from '@/lib/api';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    try { await api.post('/api/auth/forgot-password', { email }); }
    catch { /* generic 200 response either way */ }
    setSent(true);
    setLoading(false);
  }

  return (
    <AuthCard title="Reset your password" subtitle="Enter your email and we'll send you a link to set a new password.">
      {sent ? (
        <div className="space-y-4 text-sm text-fg-muted">
          <div className="p-4 rounded-lg bg-accent/10 border border-accent/30 text-accent">
            If an account exists for that email, a reset link is on its way. Check your inbox (and spam). The link expires in 1 hour.
          </div>
          <Link to="/signin" className="block text-center text-xs text-accent hover:underline">← Back to sign in</Link>
        </div>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4">
          <Input label="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" required autoComplete="email" autoFocus />
          <Button type="submit" size="lg" loading={loading} className="w-full">Send reset link</Button>
          <div className="text-center"><Link to="/signin" className="text-xs text-fg-muted hover:text-accent">Remembered it? Sign in</Link></div>
        </form>
      )}
    </AuthCard>
  );
}
